// frontend/src/components/AreaItem.jsx
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import presupuestosService from '../services/presupuestosService';
import PartidaItem from './PartidaItem';
import CrearPartidaModal from './CrearPartidaModal';
import './AreaItem.css';

const AreaItem = ({ area, isExpanded, onToggle, onRemove, onUpdate, isAprobado = false, presupuestoId, presupuestoStatus, onAbrirOrdenCompra }) => {
  const [showCrearPartidaModal, setShowCrearPartidaModal] = useState(false);
  const [expandedPartidas, setExpandedPartidas] = useState({});

  const handleAddPartida = async (partidaData) => {
    try {
      // Si es una partida nueva, crearla primero
      let partidaId = partidaData.id;
      if (!partidaId && partidaData.nombre_partida) {
        const createResponse = await presupuestosService.createPartida({
          area: area.id,
          nombre_partida: partidaData.nombre_partida,
          descripcion: partidaData.descripcion || '',
          cantidad: partidaData.cantidad || 0,
          valor_unitario: partidaData.valor_unitario || 0,
          unidad: partidaData.unidad || 'unidad',
          status: 'activo'
        });
        toast.success('Partida creada exitosamente');
      }
      setShowCrearPartidaModal(false);
      onUpdate();
    } catch (error) {
      console.error('Error al agregar partida:', error);
      toast.error('Error al agregar partida');
    }
  };

  const togglePartida = (partidaId) => {
    setExpandedPartidas(prev => ({
      ...prev,
      [partidaId]: !prev[partidaId]
    }));
  };

  return (
    <div className="area-item">
      <div className="area-header">
        <button
          className="expand-btn"
          onClick={onToggle}
          title={isExpanded ? 'Contraer' : 'Expandir'}
        >
          {isExpanded ? '▼' : '▶'}
        </button>

        <div className="area-info">
          <h3>📊 {area.nombre_area}</h3>
          <span className="area-total">Total: ${area.total_area.toLocaleString('es-CL')}</span>
        </div>

        <div className="area-actions">
          {isExpanded && !isAprobado && (
            <button
              className="btn btn-small btn-add"
              onClick={() => setShowCrearPartidaModal(true)}
              title="Agregar partida"
            >
              ➕
            </button>
          )}
          {!isAprobado && (
            <button
              className="btn btn-small btn-remove"
              onClick={onRemove}
              title="Remover área"
            >
              🗑️
            </button>
          )}
        </div>
      </div>

      {isExpanded && (
        <div className="area-content">
          <div className="partidas-list">
            {area.partidas && area.partidas.length > 0 ? (
              area.partidas.map(partida => (
                <PartidaItem
                  key={partida.id}
                  partida={partida}
                  isExpanded={expandedPartidas[partida.id]}
                  onToggle={() => togglePartida(partida.id)}
                  onUpdate={onUpdate}
                  isAprobado={isAprobado}
                  presupuestoId={presupuestoId}
                  presupuestoStatus={presupuestoStatus}
                  onAbrirOrdenCompra={onAbrirOrdenCompra}
                  area={area}
                />
              ))
            ) : (
              <div className="empty-partidas">
                <p>📭 No hay partidas en esta área</p>
                {!isAprobado && (
                  <button
                    className="btn btn-small btn-primary"
                    onClick={() => setShowCrearPartidaModal(true)}
                  >
                    Agregar Partida
                  </button>
                )}
                {isAprobado && (
                  <p style={{ color: '#ef4444', fontSize: '0.85rem', marginTop: '0.5rem' }}>
                    ⚠️ No puedes agregar partidas a un presupuesto aprobado
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {showCrearPartidaModal && (
        <CrearPartidaModal
          areaId={area.id}
          onClose={() => setShowCrearPartidaModal(false)}
          onPartidaAdded={handleAddPartida}
        />
      )}
    </div>
  );
};

export default AreaItem;
